import { initializeApp } from "firebase/app";
import firebase from "firebase/compat/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth"; // authentication library
import { getDatabase } from "firebase/database"; //real time database json
import { getFirestore } from "firebase/firestore"; //document

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// firebase.initializeApp(firebaseConfig);

export const app = initializeApp(firebaseConfig);
export const googleAuthProvider = new GoogleAuthProvider();
export const auth = getAuth();
export const rtdb = getDatabase(app);
export const fsdb = getFirestore(app);

export default firebase;
